// import React from "react";
// import { useNavigate } from "react-router-dom";

// const NotFound = () => {
//   const navigate = useNavigate();

//   return (
//     <div
//       className="d-flex flex-column justify-content-center align-items-center text-center bg-light"
//       style={{
//         minHeight: "110vh",
//         background:
//           "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
//         padding: "40px 20px",
//       }}
//     >
//       {/* Main Image */}
//       <img
//         src="https://cdn-icons-png.flaticon.com/512/7486/7486749.png"
//         alt="Page Not Found"
//         className="img-fluid mb-4"
//         style={{ width: "230px", maxWidth: "80%" }}
//       />

//       {/* 404 Text */}
//       <h1 className="display-3 fw-bold text-dark">Oops! Page Not Found</h1>
//       <p className="text-muted fs-5 mt-3" style={{ maxWidth: "600px" }}>
//         The page you’re looking for doesn’t exist, might have been moved, or is
//         temporarily unavailable. But don’t worry — let’s get you back to
//         shopping!
//       </p>

//       {/* Buttons */}
//       <div className="mt-4 d-flex gap-3 flex-wrap justify-content-center">
//         <button
//           className="btn btn-outline-secondary rounded-pill px-4 py-2"
          
//           onClick={() => {

//     navigate("/");
//   }}
//         >
//           <i className="bi bi-house-door me-2"></i> Go Home
//         </button>

//         <button
//           className="btn btn-success rounded-pill px-4 py-2"
//           onClick={() => navigate("/shop")}
//         >
//           <i className="bi bi-bag me-2"></i> Shop Now
//         </button>
//       </div>

//       <div
//         className="position-absolute bottom-0 start-0 w-100"
//         style={{
//           height: "120px",
//           background:
//             "linear-gradient(to top, rgba(0, 100, 0, 0.15), transparent)",
//         }}
//       ></div>
//     </div>
//   );
// };

// export default NotFound;
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // console.log("Go Home button clicked");
    navigate("/");
  };

  const handleShopNow = () => {
    // console.log("Shop Now button clicked");
    navigate("/shop");
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center bg-light position-relative"
      style={{
        minHeight: "110vh",
        background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
        padding: "40px 20px",
      }}
    >
      {/* Main Image */}
      <img
        src="https://cdn-icons-png.flaticon.com/512/7486/7486749.png"
        alt="Page Not Found"
        className="img-fluid mb-4"
        style={{ width: "230px", maxWidth: "80%" }}
      />

      {/* 404 Text */}
      <h1 className="display-3 fw-bold text-dark">Oops! Page Not Found</h1>
      <p className="text-muted fs-5 mt-3" style={{ maxWidth: "600px" }}>
        The page you're looking for doesn't exist, might have been moved, or is
        temporarily unavailable. But don't worry — let's get you back to
        shopping!
      </p>

      {/* Buttons - with higher z-index */}
      <div 
        className="mt-4 d-flex gap-3 flex-wrap justify-content-center"
        style={{ position: "relative", zIndex: 10 }} // Added this
      >
        <button
          className="btn btn-outline-secondary rounded-pill px-4 py-2"
          onClick={handleGoHome}
          style={{ position: "relative", zIndex: 11 }}
        >
          <i className="bi bi-house-door me-2"></i> Go Home
        </button>

        <button
          className="btn btn-success rounded-pill px-4 py-2"
          onClick={handleShopNow}
          style={{ position: "relative", zIndex: 11 }}
        >
          <i className="bi bi-bag me-2"></i> Shop Now
        </button>
      </div>

      {/* Gradient overlay - moved further down with lower z-index */}
      <div
        className="position-absolute"
        style={{
          bottom: "0",
          left: "0",
          width: "100%",
          height: "120px",
          background: "linear-gradient(to top, rgba(0, 100, 0, 0.15), transparent)",
          zIndex: 1, // Lower z-index
        }}
      ></div>
    </div>
  );
};

export default NotFound;